import { I18n } from '@calendly/i18n';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { CheckIcon } from '@calendly/ui/components/icons';
import { BareItem } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextDisabled, colorTextSecondary, primaryColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { getMemberName } from 'components/event_type_edit';
import { Layout, LayoutItem } from 'components/layout';
import { CheckboxUI } from '../../../../../components/checkbox_ui';
import { StyledUserInfoAvatar } from '../styles';
const MenuButton = props => <Layout relative grow gap="8" justify="space-between" align="center" {...props} />;
const wrapperCss = "w17ryrva";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const textWrapperCss = "t1doedme";
const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
const titleWrapperIsPhoneCss = "te0awvx";
const titleWrapperCss = "ttt3ziq";
const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, {
    [titleWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const disabledHintCss = "d1ggclr9";
const DisabledHint = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(disabledHintCss, props.className)} />;
});
const CheckIconWrapper = props => <LayoutItem padding="8" {...props} />;
export const Option = ({
  disabled,
  disabledHint,
  isMultiSelect,
  onSelect,
  selected,
  suggestion
}) => {
  const {
    data: currentUser
  } = useGetUserQuery();
  const {
    type,
    entity
  } = suggestion;
  const isOrganizationMembership = type === 'organization_membership';
  const isOrganizationInvitation = type === 'organization_invitation';
  const entityUuid = isOrganizationMembership && entity.user_uuid || isOrganizationInvitation && entity.organization_invitation_uuid;
  const handleSelection = () => {
    onSelect(suggestion);
  };
  return <BareItem role="option" aria-selected={selected ? 'true' : 'false'} disabled={isMultiSelect && disabled} onClick={handleSelection}>
      <MenuButton>
        <Wrapper>
          {isMultiSelect && <CheckboxUI checked={selected} disabled={disabled} />}
          <FullStoryExclude>
            <StyledUserInfoAvatar spaceless isNonInteractive size="small" isPendingUser={isOrganizationInvitation} letter={entity.avatar_letter} name={entity.name} src={isOrganizationMembership && entity.avatar_url} uuid={entityUuid} />
          </FullStoryExclude>
          <TextWrapper>
            <TitleWrapper>
              <BodyText size="small" weight="semibold">
                <FullStoryMask>{isOrganizationMembership && getMemberName(entity, currentUser)}</FullStoryMask>
                {isOrganizationInvitation && I18n.t('publisher.organization.memberships_picker.pending_invitation')}
              </BodyText>
              {isMultiSelect && disabled && disabledHint && <DisabledHint>{disabledHint}</DisabledHint>}
            </TitleWrapper>
            <BodyText size="x-small" color={disabled ? colorTextDisabled : colorTextSecondary}>
              <FullStoryMask>{entity.email}</FullStoryMask>
            </BodyText>
          </TextWrapper>
        </Wrapper>
        {!isMultiSelect && selected && <CheckIconWrapper>
            <CheckIcon color={primaryColor} />
          </CheckIconWrapper>}
      </MenuButton>
    </BareItem>;
};

require("./option.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option.js");